import v3 from './v3/index.js';
import v4 from './v4/index.js';
import v5 from './v5/index.js';
export { CarouselSource, CarouselType, CollectionText, SportFilterType } from './types.js';
import './v3/carousels.js';
import './v3/pages.js';
import './v4/banner.js';
import './v4/pages.js';
import './v4/carousels.js';
import './v5/pages.js';

function layout(backendAxiosInstance) {
  return {
    v3: v3(backendAxiosInstance),
    v4: v4(backendAxiosInstance),
    v5: v5(backendAxiosInstance)
  };
}

export { layout as default };
//# sourceMappingURL=index.js.map
